import * as React from 'react';
import { Table } from '../../../components/Bootstrap';
import { RouteComponentProps } from 'react-router';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { Layout, LayoutContent, Navigation, BackButton } from '../../../components';
import { LiveDeliveryReportQuery, LiveDeliveryReportQueryVariables } from './__generated__/LiveDeliveryReportQuery';
import './LiveDeliveryReport.scss';

const QUERY = gql`
  query LiveDeliveryReportQuery($venueId: ID!, $fulfillmentCenterId: ID!) {
    liveDeliveryReport(venueId: $venueId, fulfillmentCenterId: $fulfillmentCenterId) {
      location {
        name
        value
      }
      totalDrinks
      totalSales
      totalTips
    }
  }
`;

interface LiveDeliveryReportRouterParams {
  venueId: string;
  fulfillmentCenterId: string;
}

interface LiveDeliveryReportContentProps extends LiveDeliveryReportProps {
  loading: boolean;
  data?: LiveDeliveryReportQuery;
}

const LiveDeliveryReportContent = (props: LiveDeliveryReportContentProps) => {
  const onPressBack = React.useCallback(() => {
    props.history.goBack();
  }, [props.history]);

  if (props.loading) {
    return <div>Loading...</div>;
  }

  if (props.data.liveDeliveryReport.length === 0) {
    return (
      <div className='live-delivery-report'>
        <BackButton onClick={onPressBack} />
        No orders
      </div>
    );
  }

  return (
    <div className='live-delivery-report'>
      <BackButton onClick={onPressBack} />
      <h3 className='mt-4'>Table Report</h3>
      <Table>
        <thead>
          <tr>
            {props.data.liveDeliveryReport[0].location.map((location) => (
              <th key={location.name}>{location.name}</th>
            ))}
            <th>Total Drinks</th>
            <th>Total Sales</th>
            <th>Total tips</th>
          </tr>
        </thead>
        <tbody>
          {props.data.liveDeliveryReport.map((row, index) => (
            <tr key={index}>
              {row.location.map((location) => (
                <td key={location.name}>{location.value}</td>
              ))}
              <td>{row.totalDrinks}</td>
              <td>{row.totalSales}</td>
              <td>{row.totalTips}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

interface LiveDeliveryReportProps extends RouteComponentProps<LiveDeliveryReportRouterParams> {}

export const LiveDeliveryReport = (props: LiveDeliveryReportProps) => {
  const { loading, data, error } = useQuery<LiveDeliveryReportQuery, LiveDeliveryReportQueryVariables>(QUERY, {
    variables: {
      venueId: props.match.params.venueId,
      fulfillmentCenterId: props.match.params.fulfillmentCenterId,
    },
  });

  return (
    <Layout>
      <Navigation />
      <Layout.TopBar>
        <Layout.TopBar.Left>
          <Layout.TopBar.Title>My Menu</Layout.TopBar.Title>
        </Layout.TopBar.Left>
      </Layout.TopBar>
      <LayoutContent error={error}>
        <LiveDeliveryReportContent loading={loading} data={data} {...props} />
      </LayoutContent>
    </Layout>
  );
};
